import React from 'react'
import Pharmacy from '../../Components/Doctor/Pharmacy/Pharmacy'

const DoctorPharmacyPage = () => {
  return (
    <div className='p-5'>
      <Pharmacy/>
    </div>
  )
}

export default DoctorPharmacyPage